// extracted by mini-css-extract-plugin
module.exports = {"slide":"add_slide_3EHlo","slide-reverse":"add_slide-reverse_25xk7","pageContent":"add_pageContent_XoYNJ","card-wrapper":"add_card-wrapper_3EzGt","footer":"add_footer_23ttO"};